export default __webpack_public_path__ + "static/media/typescript.8e08c216.png";